<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-card>
        <tt-tabs [(ttSelectedId)]="selectedBgOperationTrListSelection" (ttSelectedIdChange)="onTabChanged()">
            <tt-tab ttId="0" ttLabel="operation_direct"></tt-tab>
            <tt-tab ttId="1" ttLabel="operation_indirect"></tt-tab>
        </tt-tabs>
    </tt-card>

    <tt-list [ttData]="itemsListOperations"></tt-list>
</tt-page>
